import { useQuery } from '@tanstack/react-query';
import { getNotices } from '../../infrastructure/api/noticesApi';
import { qKeys } from './keys';
import { queryDefaults } from './queryPolicy';

/** E16 — GET /notices (role-filtered, non-expired). */
export function useNotices() {
  return useQuery({ queryKey: qKeys.notices, queryFn: getNotices, ...queryDefaults });
}
